"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  HardDrive: ['hard-drive', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,15.251v4a2.007,2.007,0,0,0,2,2h19a2.006,2.006,0,0,0,2-2v-4a2.005,2.005,0,0,0-2-2H2.5A2.006,2.006,0,0,0,.5,15.251Zm19.5-1a1,1,0,1,1-1,1A1,1,0,0,1,20,14.251ZM3.5,17.5h17a.75.75,0,0,1,0,1.5H3.5a.75.75,0,0,1,0-1.5Z', 'M2.5,11.751h19a3.4,3.4,0,0,1,1.34.276.249.249,0,0,0,.34-.291L21.49,5.063v0A3.213,3.213,0,0,0,18.5,2.751H5.5A3.213,3.213,0,0,0,2.511,5.063L.82,11.736a.249.249,0,0,0,.34.291A3.4,3.4,0,0,1,2.5,11.751Z']],
  HardDrive1: ['hard-drive-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,11.751H1a1,1,0,0,0-1,1v3a2.493,2.493,0,0,0,1.591,2.316.25.25,0,0,1,.159.233v1.2a.75.75,0,0,0,1.5,0v-1a.25.25,0,0,1,.25-.25h17a.25.25,0,0,1,.25.25v1a.75.75,0,1,0,1.5,0V18.3a.25.25,0,0,1,.159-.233A2.493,2.493,0,0,0,24,15.751v-3A1,1,0,0,0,23,11.751Zm-3,4a1,1,0,1,1,1-1A1,1,0,0,1,20,15.751Zm-2-1a1,1,0,1,1-1-1A1,1,0,0,1,18,14.751Zm-3,0a1,1,0,1,1-1-1A1,1,0,0,1,15,14.751Z', 'M1.084,10.751H22.916a.994.994,0,0,0,.928-.629.983.983,0,0,0-.219-1.075L19.061,4.19A1.494,1.494,0,0,0,18,3.751H6a1.5,1.5,0,0,0-1.072.45L.394,9.027a1,1,0,0,0,.69,1.724Z']],
  Turntable: ['turntable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21,2.5A2.5,2.5,0,0,0,18.5,0H5.5A2.5,2.5,0,0,0,3,2.5v19A2.5,2.5,0,0,0,5.5,24h13A2.5,2.5,0,0,0,21,21.5ZM18,22a1,1,0,1,1,1-1A1,1,0,0,1,18,22Zm-6.7-1.818a.5.5,0,0,1,.2.4V21a.5.5,0,0,1-.5.5H6.833A1.335,1.335,0,0,1,5.5,20.168v-1.6a.249.249,0,0,1,.073-.177l4.457-4.447a.75.75,0,0,0-1.06-1.061L7.519,14.339a.25.25,0,0,1-.364-.011,6.542,6.542,0,1,1,2.839,1.85.249.249,0,0,0-.254.061L8.358,17.62A.249.249,0,0,0,8.385,18Z', 'M10.000 10.001 A2.000 2.000 0 1 0 14.000 10.001 A2.000 2.000 0 1 0 10.000 10.001 Z']],
  Turntable1: ['turntable-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,1.5A1.5,1.5,0,0,0,20.5,0H3.5A1.5,1.5,0,0,0,2,1.5v21A1.5,1.5,0,0,0,3.5,24h17A1.5,1.5,0,0,0,22,22.5Zm-3.5,10A6.5,6.5,0,0,1,12,18a6.4,6.4,0,0,1-2.239-.415.25.25,0,0,0-.295.1L7.051,21.305a1.013,1.013,0,0,1-1.539.153L3.821,19.767a.987.987,0,0,1-.068-1.331.249.249,0,0,1,.372-.017C4.56,18.861,5.688,20,5.688,20a.76.76,0,0,0,1.161-.123l3.573-5.611a.5.5,0,0,0-.691-.69L7.039,15.294a.25.25,0,0,1-.338-.067A6.419,6.419,0,0,1,5.5,11.5a6.5,6.5,0,0,1,13,0Zm-1.25,9v1a.75.75,0,1,1-1.5,0v-1a.75.75,0,0,1,1.5,0ZM4.5,3.5a1,1,0,1,1,1,1A1,1,0,0,1,4.5,3.5Zm13,0a1,1,0,1,1,1,1A1,1,0,0,1,17.5,3.5Zm1.25,17a.75.75,0,0,1,1.5,0v1a.75.75,0,1,1-1.5,0Z', 'M12,9.5a2,2,0,1,0,2,2A2,2,0,0,0,12,9.5Zm0,3a1,1,0,1,1,1-1A1,1,0,0,1,12,12.5Z']]
};
exports["default"] = _default;